import {
  deviceType,
  _getDeviceInfo,
  _getUserInfo,
  _getItemFromLocalDecrypted,
} from "network-helper";
import * as _ from "lodash";
import { _getItemFromLocal } from "../../Utils/Helpers/LocalKeys";
import { ELANGUAGEKEYS } from "../Enums/ELanguageKeys";

export const inputParams = () => {
  const userInfo = _getUserInfo()!==null ? JSON.parse(_getUserInfo()):"";
  const deviceDetails = _getDeviceInfo()!==null ? JSON.parse(_getDeviceInfo()):"";
  const currentProfile = JSON.parse(_getItemFromLocalDecrypted("_cp"));
  const primaryProfile = JSON.parse(_getItemFromLocalDecrypted("_pp"));
  const localLanguage=_getItemFromLocal("_lang")!==null ? _getItemFromLocal("_lang") : ELANGUAGEKEYS.ENGLISH;
  
  const deviceJioId = _.get(deviceDetails, "hhub_id") || _.get(currentProfile, "jio_id") || _.get(userInfo, "healthhub_id") || _.get(primaryProfile, "jio_id", "");
  const deviceAuthKey = _.get(deviceDetails, "auth_key") || _.get(currentProfile, "auth_key") || _.get(userInfo, "auth_key") || _.get(primaryProfile, "auth_key", "");


  return {
    primary_user_id: _.get(deviceDetails, "primary_user_id", ""),
    device_user_id: _.get(deviceDetails, "device.user_id", ""),
    device_id: _.get(deviceDetails, "device.id", ""),
    device_type: deviceType,
    device_jio_id:  deviceJioId,
    device_auth_key:deviceAuthKey,
    version_number: _.get(deviceDetails, "device.version_no", ""),
    language: localLanguage || _.get(deviceDetails, "device.lang_name", ""),
    device_model: _.get(deviceDetails, "device.device_model", ""),
  };
};
